import React, { useCallback, useMemo, useState } from 'react';

import { List, Popover } from '@mui/material';
import PropTypes from 'prop-types';

import ContextMenuContext from './ContextMenuContext';

const ContextMenu = ({ open, onClose, children, ...props }) => {
  const [selectedItemId, setSelectedItemId] = useState(null);

  const onSelectMenuItem = useCallback(e => setSelectedItemId(e.currentTarget.dataset.id), []);

  const contextValue = useMemo(
    () => ({ selectedItemId, onSelectMenuItem, onClose }),
    [selectedItemId, onSelectMenuItem, onClose],
  );

  return (
    <Popover disableEnforceFocus open={open} onClose={onClose} {...props}>
      <ContextMenuContext.Provider value={contextValue}>
        <List disablePadding>{children}</List>
      </ContextMenuContext.Provider>
    </Popover>
  );
};

ContextMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ContextMenu;
